<template>
    <span v-if="isKata"> {{ translate("fight.result.details.points") }} {{ kataTotalScore }} </span>
    <span v-else-if="hasSubmissionDetail">
        {{ getTranslatedFightFinishSubmission() }}
    </span>
    <span v-else>
        {{ getTranslatedFightFinishType() }}
    </span>
</template>

<script>
    import translatorMixin from "../Common/translatorMixin";

    export default {
        name: "result",
        mixins: [translatorMixin],
        props: ["result"],
        computed: {
            isKata() {
                return this.result && this.result.type === "kata";
            },
            kataTotalScore() {
                const total = this.result && this.result.totalScore;
                return typeof total === "number" ? total.toFixed(1) : total;
            },
            hasSubmissionDetail() {
                if (this.result && !!this.result.submission) {
                    return true;
                }

                return false;
            },
            resultType() {
                if (this.result && this.result.fightFinishType === "doubleDisqualification") {
                    return "doubleDisqualification";
                }
                if (this.result && this.result.type) {
                    return this.result.type;
                }
                if (this.isByeFightWinner()) {
                    return "bye";
                }
                return null;
            },
        },
        methods: {
            getTranslatedFightFinishSubmission() {
                if (this.result && this.result.submission) {
                    const key = `submission.${this.result.submission}`;
                    return this.translate(key);
                }

                return "";
            },
            getTranslatedFightFinishType() {
                if (this.result && this.result.fightFinishType) {
                    const key = `fight.result.details.finish_type.${this.result.fightFinishType}`;
                    return this.translate(key);
                }

                return this.translate(`fight.result.details.finish_type.none`);
            },
        },
    };
</script>

<style scoped></style>
